import _ from 'lodash';
import React from 'react';
import numeral from 'numeral';
import Title from '$components/library/Title';
import SpinnerError from '$components/library/SpinnerError';
import { Query } from '@apollo/react-components';
import { gql } from '@apollo/client';
import styles from './styles.scss';

const PRODUCT_VIDEOS = gql`
  query ProductVideos($input: ProductInput!) {
    product(input: $input) {
      product {
        uuid
        videos {
          uuid
          title
          productSlug
          href
          thumbnailSrc
          durationMs
          position
        }
      }
    }
  }
`;

const PRODUCT_SLUGS_WITH_VIDEOS = ['finra-sie', 'finra-series-7'];

const getDuration = (durationMs) => {
  let durationS = Math.round(durationMs / 1000);
  if (durationS < 60) {
    const secondsF = numeral(durationS).format('00');
    return `0:${secondsF}`;
  }

  let durationM = Math.floor(durationS / 60);
  durationS %= 60;
  const secondsF = numeral(durationS).format('00');
  if (durationM < 60) {
    return `${durationM}:${secondsF}`;
  }

  const durationH = Math.floor(durationM / 60);
  durationM %= 60;
  const minutesF = numeral(durationM).format('00');
  return `${durationH}:${minutesF}:${secondsF}`;
};

const VideoTile = (props) => {
  const { video } = props;
  const { title, durationMs, thumbnailSrc, href } = video;
  const duration = getDuration(durationMs);
  return (
    <a className={styles.videoTile} href={href} target="_blank" rel="noopener noreferrer">
      <img src={thumbnailSrc} className={styles.videoTileThumbnail} />
      <div className={styles.videoTileInfo}>
        <div className={styles.videoTileTitle}>{title}</div>
        <div className={styles.videoTileDuration}>{duration}</div>
      </div>
    </a>
  );
};

const VideoTiles = (props) => {
  const { videos } = props;
  const sortedVideos = _.sortBy(videos, 'position');
  return (
    <div className={styles.videoTiles}>
      {sortedVideos.map((video) => (
        <VideoTile key={video.href} video={video} />
      ))}
    </div>
  );
};

const VideoLibrary = ({ productSlug }) => {
  if (!_.includes(PRODUCT_SLUGS_WITH_VIDEOS, productSlug)) {
    return null;
  }

  return (
    <div>
      <Title size="monkey">Video library</Title>
      <Query query={PRODUCT_VIDEOS} variables={{ input: { slug: productSlug } }}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return <SpinnerError error={error} />;
          }

          const {
            product: { product },
          } = data;
          const { videos } = product;

          return <VideoTiles videos={videos} />;
        }}
      </Query>
    </div>
  );
};

export default VideoLibrary;
